export const AUTH_USER = 'AUTH_USER'

export const SIGN_IN = 'SIGN_IN'
export const SIGN_IN_SUCCESS = 'SIGN_IN_SUCCESS'
export const SIGN_IN_FAIL = 'SIGN_IN_FAIL'

export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS'
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE'

export const SET_IS_RESETTING = 'SET_IS_RESETTING'

export const REQUEST_RESET = 'REQUEST_RESET'
export const REQUEST_RESET_SUCCESS = 'REQUEST_RESET_SUCCESS'
export const REQUEST_RESET_FAILURE = 'REQUEST_RESET_FAILURE'

export const PASSWORD_RESET = 'PASSWORD_RESET'
export const PASSWORD_RESET_SUCCESS = 'PASSWORD_RESET_SUCCESS'
export const PASSWORD_RESET_FAILURE = 'PASSWORD_RESET_FAILURE'
